import styled from 'styled-components';

export const FormInputContainer = styled.div`
  position: relative;
`;

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  padding: 8px 45px 8px 8px;
  border: 1px solid
    ${({ theme, hasError }) => (hasError ? theme.colors.red800 : theme.colors.neutral100)};
  border-radius: 4px;
  font-size: 18px;
  transition: border-color 0.2s;
  height: 46px;

  &:focus {
    outline: none;
    border-color: ${({ theme, hasError }) =>
      hasError ? theme.colors.red800 : theme.colors.primary600};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral500};
  }
`;

export const ErrorMessage = styled.span`
  display: flex;
  align-items: end;
  gap: 0.3rem;
  color: ${({ theme }) => theme.colors.red800};
  font-size: 12px;
  margin-top: 0.5rem;
`;

export const RightIconContainer = styled.div`
  position: absolute;
  right: 15px;
  top: 45px;
  cursor: pointer;
`;
